import { useState } from "react";
import { FaFileAlt } from "react-icons/fa";

const TournamentRules = ({ rules }) => {
  const [showRules, setShowRules] = useState(false);

  return (
    <div className="max-w-3xl mx-auto bg-gray-50 rounded-2xl shadow-lg p-6 mt-6">
      <div
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setShowRules((prev) => !prev)}
      >
        <h3 className="text-xl font-bold text-gray-800 flex items-center gap-2">
          <FaFileAlt className="text-blue-500" /> Reglamento del torneo
        </h3>
        <span className="text-gray-500">{showRules ? "▲" : "▼"}</span>
      </div>

      {showRules && (
        <div className="mt-4 p-4 bg-white rounded-xl shadow-inner">
          {rules ? (
            <p className="text-gray-700 whitespace-pre-line">{rules}</p>
          ) : (
            <div className="text-center py-6 text-gray-400">
              <p>No se ha cargado un reglamento para este torneo.</p>
              <p className="mt-2">Cuando esté disponible, lo verás aquí.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TournamentRules;
